
import {Routes, Route, Link} from "react-router-dom";
import HomePage from "./pages/home/home_page";
import IndexPage from "./pages";
import PageNotFound from "./pages/404/404_page";
import FormPage from "./pages/form/form_page";
import AboutPage from "./pages/about/about";
import ServicesPage from "./pages/services/services";
import SitemapPage from "./pages/about/sitemap";
import LegalPage from "./pages/about/legal/page";
import AppliedFormPage from "./pages/form/thank-you_page";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";

function App() {

  return (
    <>
        <Routes>

            <Route path="/" element={<IndexPage />}>
                <Route index path="/" element={<HomePage />} />

                {/*<Route index exact path="/services" element={<ServicesPage />} />*/}

                {/*<Route index exact path="/company" element={<AboutPage />} />*/}

                {/*<Route index exact path="/contacts" element={<FormPage />} />*/}
                {/*<Route index exact path="/enquire" element={<FormPage />} />*/}
                {/*<Route index exact path="/enquire-applied" element={<AppliedFormPage />} />*/}

                {/*<Route index exact path="/legal/" element={<LegalPage />} />*/}
                {/*<Route index exact path="/legal/:page" element={<LegalPage />} />*/}

                {/*<Route index exact path="/sitemap" element={<SitemapPage />} />*/}


                <Route index exact path="/information/privacy-policy" element={<PrivacyPolicy />} />
                <Route index exact path="/information/terms-of-service" element={<TermsOfService />} />

            </Route>

            <Route path="*" element={<PageNotFound />}/>

        </Routes>
    </>
  );
}

export default App;
